import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
  
    console.log(email)
    if (email) {
      if ( email === 'secretary@adelaidetamil.com.au' ) {
        if (password === 'secretary@123') {
          localStorage.setItem('isAuthenticated', 'true');
          localStorage.setItem('email', email);
          navigate('/admin/eventmanagement');
        }
        else{
          setError('Invalid Password');
          toast.error('Invalid Password');
          setPassword('');
        }
      }

      if ( email ===  'president@adelaidetamil.com.au' ) {
        console.log("hi")
        if (password === 'president@123') {
          localStorage.setItem('isAuthenticated', 'true');
          localStorage.setItem('email', email);
          navigate('/admin/eventmanagement');
        }
        else{
          setError('Invalid Password');
          toast.error('Invalid Password');
          setPassword('');
        }
      }

      else {
        setError('Invalid email or password');  
        toast.error('Invalid email or password');
        setPassword('');
      }
      
    } else {
      setError('Invalid email or password');  
      toast.error('Invalid email or password');
      setPassword('');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <ToastContainer />

      <form 
        onSubmit={handleSubmit} 
        className="bg-white shadow-md rounded-lg p-8 w-full max-w-md"
      >
        <img src="/assets/logo.svg" alt="" className='w-full flex items-center justify-center py-4 h-[8em]' />
        <h2 className="text-2xl font-bold mb-6 text-center">Admin Login</h2>
        
        {/* {error && (
          <div className="mb-4 text-red-500 text-center">
            {error}
          </div>
        )} */}
        
        <div className="mb-4">
          <label 
            htmlFor="email" 
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Email
          </label>
          <input 
            type="email" 
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your email"
          />
        </div>
        
        <div className="mb-6">
          <label 
            htmlFor="password" 
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Password
          </label>
          <input 
            type="password" 
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your password"
          />
        </div>
        
        <button 
          type="submit"
          className="w-full py-2 text-white font-bold rounded-md transition-colors duration-300"
          style={{ backgroundColor: '#272938' }}
          onMouseEnter={(e) => e.target.style.opacity = '0.9'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
          onFocus={(e) => e.target.style.opacity = '0.9'}
          onBlur={(e) => e.target.style.opacity = '1'}
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default Login;